import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { CardIndividual } from '@cotyorg/ccx-organism-cards';
import FooterList from '../FooterList/FooterList';
import FooterAccordion from '../FooterAccordion/FooterAccordion';
import Copyright from '../Copyright/Copyright';

const FooterTwoRow = ({
  footer,
  currentBreakpoint,
  minusIconSrc,
  plusIconSrc,
  card,
  countrySelector,
  headingLevel = 5,
  isServedFromLegacySite,
  navigationLinkIconWidth,
  navigationLinkIconHeight,
}) => {
  const { copyright } = footer;
  const isLargeBreakpoint = currentBreakpoint && currentBreakpoint.includes('large');
  const navLimit = card ? 2 : (countrySelector ? 4 : 3);
  const copyrightPages = R.prop('pages')(copyright);
  /*
    Creating copy of footer so all variants render correctly.
    Probably not needed for sites when only one footer variant is shown at a time
  */
  const footerClone = R.clone(footer);
  copyright.showPages = true;

  if (countrySelector && copyrightPages) {
    footerClone.pages.push(copyright.pages[0]);
    copyright.showPages = false;
  }

  return (
    <footer className="footer">
      {isLargeBreakpoint && (
        <FooterList
          footer={footerClone}
          extraClass="footer-list--two-row"
          forceSectionTitles
          navLimit={navLimit}
          headingLevel={headingLevel}
        >
          {
            card && (
              <CardIndividual
                {...card}
                fullWidth={false}
              />
            )
          }
        </FooterList>
      )}
      {!isLargeBreakpoint && (
        <FooterAccordion
          footer={footerClone}
          extraClass="footer-accordion--two-row"
          openAccordionButtonExtraClass="footer-accordion__accordion-button"
          accordionBodyExtraClass="footer-accordion__accordion-body"
          minusIconSrc={minusIconSrc}
          plusIconSrc={plusIconSrc}
          navigationLinkIconWidth={navigationLinkIconWidth}
          navigationLinkIconHeight={navigationLinkIconHeight}
        >
          {card && (
            <CardIndividual
              {...card}
              fullWidth
            />
            )
          }
        </FooterAccordion>
      )}
      <Copyright
        {...copyright}
        countrySelector={countrySelector}
        isServedFromLegacySite={isServedFromLegacySite}
      />
    </footer>
  );
};

FooterTwoRow.propTypes = {
  footer: PropTypes.shape({
    pages: PropTypes.array.isRequired,
    card: PropTypes.object,
    copyright: PropTypes.shape({
      text: PropTypes.string.isRequired,
      pages: PropTypes.arrayOf(PropTypes.shape({
        slug: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
        openInNewWindow: PropTypes.bool,
        pages: PropTypes.arrayOf(PropTypes.shape({
          slug: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          pages: PropTypes.array,
          openInNewWindow: PropTypes.bool,
        })),
      })),
    }).isRequired,
  }).isRequired,
  currentBreakpoint: PropTypes.string.isRequired,
  plusIconSrc: PropTypes.string,
  minusIconSrc: PropTypes.string,
  countrySelector: PropTypes.shape({
    visible: PropTypes.bool,
    padding: PropTypes.bool,
    beforeCopyright: PropTypes.bool,
    showToggleIcon: PropTypes.bool,
  }),
  headingLevel: PropTypes.number,
  navigationLinkIconWidth: PropTypes.number,
  navigationLinkIconHeight: PropTypes.number,
};

export default FooterTwoRow;
